import { MixpanelPolicyPayload } from './generic-entity-types';

export interface ClaimLinkAccessedPayload extends MixpanelPolicyPayload {}

export function generateClaimLinkAccessedProperties(payload: ClaimLinkAccessedPayload): ClaimLinkAccessedPayload {
  return payload;
}
